import React, { useMemo } from "react";
import { IWebsiteBuilderRichTextRenderOptions, websiteBuilderRenderRichTextToReact } from "./websiteBuilderRichTextRenderer";

export function WebsiteBuilderRichTextStatic(props: IWebsiteBuilderRichTextRenderOptions) {
  const { content, extensions } = props;

  const renderedContent = useMemo(
    () => websiteBuilderRenderRichTextToReact({ content, extensions }),
    [content, extensions],
  );

  return <>{renderedContent}</>;
}
